/**
 * StudentActivitiesScreen — l'onglet Activités de l'espace élève (adaptateur primaire).
 *
 * Fil : `useStudentActivitiesData` (la relecture du compte) + `studentActivitiesViewModel` (« À
 * faire », « Faites ») + `useStudentActivitiesState` (lancer, rouvrir, réalisations, génération) +
 * `useStudentTodoReorder` (ranger « À faire », enregistré sur le serveur) →
 * `<ActivitiesPage voice="student">`, la page du parent sans sélection ni archives.
 *
 * « Générer une activité » est la seule surface posée par-dessus la liste ; elle ne se monte qu'à
 * l'ouverture (`StudentGenerateActivityOverlay`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { ActivitiesPage } from "../../../../../../design-system"
import {
    studentActivitiesViewModel,
    todoReorderNotice,
} from "../../../../view-models/student/Activities/studentActivitiesViewModel"
import { StudentGenerateActivityOverlay } from "./StudentGenerateActivityOverlay"
import { useStudentActivitiesData } from "./useStudentActivitiesData"
import { useStudentActivitiesState } from "./useStudentActivitiesState"
import { useStudentTodoReorder } from "./useStudentTodoReorder"

export function StudentActivitiesScreen() {
    const { refresh } = useStudentActivitiesData()
    const vm = useSelector(studentActivitiesViewModel)
    const { studentId, generateOpen, foldKey, actions } = useStudentActivitiesState()
    // Un refus du serveur dit que la liste a changé de son côté : le compte se relit.
    const todoReorder = useStudentTodoReorder(refresh)

    return (
        <>
            <ActivitiesPage
                key={foldKey}
                voice="student"
                activities={vm.activities}
                doneActivities={vm.doneActivities}
                showDone={vm.showDone}
                loading={vm.loading}
                error={vm.error}
                onRetry={refresh}
                onOpenActivity={actions.launch}
                onOpenDoneActivity={actions.openDone}
                onSeeAllDone={actions.seeAllDone}
                onGenerate={actions.openGenerate}
                onReorder={todoReorder.reorder}
                reorderNotice={todoReorderNotice(todoReorder.failure)}
                onDismissReorderNotice={todoReorder.dismiss}
            />
            <StudentGenerateActivityOverlay
                studentId={studentId}
                onCreated={refresh}
                open={generateOpen}
                onClose={actions.closeGenerate}
            />
        </>
    )
}
